import type { InputHTMLAttributes } from "react"

import { cn } from "../../lib/utils"

type TextInputProps = InputHTMLAttributes<HTMLInputElement> & {
  hasError?: boolean
}

export function TextInput({ className, hasError = false, ...rest }: TextInputProps) {
  return (
    <input
      className={cn(
        "h-9 w-full rounded-lg border border-input bg-card px-3 text-sm text-foreground shadow-card outline-none",
        "transition-[border-color,box-shadow,background-color] duration-200 placeholder:text-muted-foreground",
        "hover:border-foreground/15 focus-visible:ring-2 focus-visible:ring-ring/30",
        "disabled:cursor-not-allowed disabled:bg-muted/40 disabled:text-muted-foreground",
        hasError && "border-destructive focus-visible:ring-destructive/25",
        className
      )}
      aria-invalid={hasError || undefined}
      {...rest}
    />
  )
}
